import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { TrendingUp, Shield, LineChart, Users, BarChart, FileText, PiggyBank, Building } from 'lucide-react';
import PageMeta from '@/components/SEO/PageMeta';

const Services = () => {
  const servicesList = [
    {
      title: "Investissement",
      description: "Stratégies d'investissement personnalisées adaptées à vos objectifs financiers et à votre tolérance au risque.",
      icon: <TrendingUp className="h-8 w-8 text-patrimoine-gold" />
    },
    {
      title: "Protection patrimoniale",
      description: "Solutions pour protéger et préserver votre patrimoine face aux aléas de la vie et optimiser sa transmission.",
      icon: <Shield className="h-8 w-8 text-patrimoine-gold" />
    },
    {
      title: "Optimisation fiscale",
      description: "Optimisation fiscale légale pour réduire votre imposition tout en respectant strictement la législation en vigueur.",
      icon: <LineChart className="h-8 w-8 text-patrimoine-gold" />
    },
    {
      title: "Transmission",
      description: "Planification successorale pour transmettre votre patrimoine à vos proches dans les meilleures conditions.",
      icon: <Users className="h-8 w-8 text-patrimoine-gold" />
    },
    {
      title: "Analyse de portefeuille",
      description: "Analyse détaillée de votre portefeuille existant pour identifier les opportunités d'optimisation et de diversification.",
      icon: <BarChart className="h-8 w-8 text-patrimoine-gold" />
    },
    {
      title: "Planification de retraite",
      description: "Élaboration de stratégies pour préparer votre retraite et maintenir votre niveau de vie actuel.",
      icon: <FileText className="h-8 w-8 text-patrimoine-gold" />
    },
    {
      title: "Épargne et placement",
      description: "Conseils personnalisés en matière d'épargne et placement pour faire fructifier votre capital.",
      icon: <PiggyBank className="h-8 w-8 text-patrimoine-gold" />
    },
    {
      title: "Investissement immobilier",
      description: "Accompagnement dans vos projets d'investissement immobilier, de la sélection à la gestion.",
      icon: <Building className="h-8 w-8 text-patrimoine-gold" />
    }
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <PageMeta 
        title="La Patrimoniale - Nos Services de Gestion de Patrimoine à Paris"
        description="Découvrez tous les services de La Patrimoniale, cabinet de gestion de patrimoine à Paris : stratégies d'investissement, conseil en placements financiers et immobiliers, optimisation fiscale, planification de retraite, transmission, analyse de portefeuille, épargne et protection patrimoniale. La Patrimoniale propose des solutions personnalisées et accompagne chaque client dans la réussite de ses projets et la valorisation de son patrimoine, en toute indépendance et transparence."
        keywords="La Patrimoniale, services gestion patrimoine, conseil patrimonial Paris, optimisation fiscale, investissement immobilier, planification retraite, placement financier, transmission patrimoine, épargne, protection patrimoine, analyse portefeuille, accompagnement patrimonial, gestion fortune, expert gestion patrimoine, cabinet patrimoine Paris"
        canonical="https://www.la-patrimoniale-gestion.com/services"
      />
      
      <main className="flex-grow pt-20">
        <section className="py-12 bg-gray-50">
          <div className="container mx-auto px-6">
            <h1 className="section-title text-center mb-4">Nos Services</h1>
            <p className="text-center text-patrimoine-muted max-w-2xl mx-auto mb-12">
              Découvrez notre gamme complète de services de gestion de patrimoine, conçus pour répondre à vos besoins spécifiques.
            </p>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {servicesList.map((service, index) => (
                <Card key={index} className="border-t-4 border-t-patrimoine-gold hover:shadow-lg transition-shadow duration-300">
                  <CardHeader>
                    <div className="mb-4">
                      {service.icon}
                    </div>
                    <CardTitle className="text-xl font-serif">{service.title}</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="text-patrimoine-muted">{service.description}</p>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default Services;
